import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { grpEditAction, grpUpdateAction } from "../../../../../modules/fieldgroups/action";
import "../../../../../style";
import FieldGroupForm from "./FieldGroupForm";


class EditFieldGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: "",
      errorMessage: {}
    };
  }

  handleSubmit = fieldGroupInfo => {
    fieldGroupInfo.id = this.props.selectedGrp.id;
    this.props.grpUpdateAction(fieldGroupInfo);
    //this.props.grpEditAction(fieldGroupInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.grpUpdated && nextProps.grpUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/field-groups" />;
    }
    return (
      <FieldGroupForm
        buttonLabel="Update"
        formLabel="Edit your field group"
        fieldGroupInfo={this.props.selectedGrp}
        handleSubmit={this.handleSubmit}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedGrp: state.fieldGroupReducer.selectedGrp,
    grpUpdated: state.fieldGroupReducer.grpUpdated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ grpUpdateAction, grpEditAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditFieldGroup);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/EditFieldGroup.js